import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Container,
	Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { developAxios } from "../../axios.config";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import moment from "moment";

const SpecificUserData = () => {
	const { userId } = useParams<{ userId: string }>();
	const [expanded, setExpanded] = React.useState<string | false>(false);
	const [type, setType] = useState<"quiz" | "coding" | "hybrid">("quiz");
	const { data, isLoading } = useQuery(["user-data", userId, type], () =>
		developAxios(localStorage.getItem("token") || "").get(
			"/admin/user/user-data/" + userId,
			{
				params: {
					type,
				},
			}
		)
	);
	const renderedRowsExamData = (
		<table className="min-w-full bg-white border border-gray-300">
			<thead>
				<tr>
					<th className="border border-gray-300 px-4 py-2">Name</th>
					<th className="border border-gray-300 px-4 py-2">Score</th>
					<th className="border border-gray-300 px-4 py-2">
						No of tabs
					</th>
					<th className="border border-gray-300 px-4 py-2">
						Submit Date
					</th>
				</tr>
			</thead>
			<tbody>
				{type === "quiz"
					? data &&
					  data.data.examData.map((each: any, index: number) => (
							<tr key={index}>
								<td className="border border-gray-300 px-4 py-2">
									{each.examId && each.examId.examName}
								</td>
								<td className="border border-gray-300 px-4 py-2">
									{each.finalScore || 0}
								</td>
								<td className="border border-gray-300 px-4 py-2">
									{each.tabsopened || 0}
								</td>
								<td className="border border-gray-300 px-4 py-2">
									{moment(each.submit_date).format(
										"DD-MM-YYYY h:mm:ss a"
									) || 0}
								</td>
							</tr>
					  ))
					: type === "coding"
					? data &&
					  data.data.examData.map((each: any, index: number) => (
							<tr key={index}>
								<td className="border border-gray-300 px-4 py-2">
									{each.examId && each.examId.name}
								</td>
								<td className="border border-gray-300 px-4 py-2">
									{each.totalScore || 0}
								</td>
								<td className="border border-gray-300 px-4 py-2">
									{each.noOftabs || 0}
								</td>
								<td className="border border-gray-300 px-4 py-2">
									{moment(each.submit_date).format(
										"DD-MM-YYYY h:mm:ss a"
									) || 0}
								</td>
							</tr>
					  ))
					: data &&
					  data.data.examData.map((each: any, index: number) => (
							<tr key={index}>
								<td className="border border-gray-300 px-4 py-2">
									{each.examID && each.examID.nameoftheExam}
								</td>
								<td className="border border-gray-300 px-4 py-2">
									{each.quizresults.finalScore +
										each.coderesults.totalScore || 0}
								</td>
								<td className="border border-gray-300 px-4 py-2">
									{each.noOftabs || 0}
								</td>
								<td className="border border-gray-300 px-4 py-2">
									{moment(each.submitDate).format(
										"DD-MM-YYYY h:mm:ss a"
									) || 0}
								</td>
							</tr>
					  ))}
			</tbody>
		</table>
	);

	return (
		<Container
			maxWidth="md"
			sx={{
				py: 2,
				height: "100vh",
				backgroundColor: "#f5f5f5",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<div className="text-3xl font-semibold mb-4 text-center text-sky-600">
				User Details
			</div>
			<div className="flex">
				<div className="w-[100%]">
					<div>
						<span className="font-semibold text-sky-600">
							First Name:{" "}
						</span>
						{data && (data.data.user.firstName || "")}
					</div>
					<div>
						<span className="font-semibold text-sky-600">
							Last Name:{" "}
						</span>
						{data && (data.data.user.lastName || "")}
					</div>
					<div>
						<span className="font-semibold text-sky-600">
							Email:{" "}
						</span>
						{data && (data.data.user.email || "")}
					</div>
				</div>
				<div className="w-[100%] flex justify-center">
					<img
						src={data && data.data.user.profile_pic}
						alt="user-pfp"
						className="w-[100px] h-[100px]"
					/>
				</div>
			</div>
			<Accordion
				classes={{
					root: "",
				}}
				expanded={expanded === "panel1"}
				onChange={() => {
					if (expanded === "panel1") {
						setExpanded(false);
						return;
					}
					setExpanded("panel1");
					setType("quiz");
				}}
				className="mt-4"
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1a-content"
					id="panel1a-header"
				>
					<Typography>Quiz Results</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						{!isLoading ? (
							<>
								{renderedRowsExamData && (
									<div
										style={{
											maxHeight: "40vh",
											minHeight: "40vh",
											height: "40vh",
											overflowY: "scroll",
										}}
									>
										{renderedRowsExamData}
									</div>
								)}
							</>
						) : (
							<>Loading</>
						)}
					</Typography>
				</AccordionDetails>
			</Accordion>
			<Accordion
				expanded={expanded === "panel2"}
				onChange={() => {
					if (expanded === "panel2") {
						setExpanded(false);
						return;
					}
					setExpanded("panel2");
					setType("coding");
				}}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel2a-content"
					id="panel2a-header"
				>
					<Typography>Coding Results</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						{!isLoading ? (
							<>
								{renderedRowsExamData && (
									<div
										style={{
											maxHeight: "40vh",
											minHeight: "40vh",
											height: "40vh",
											overflowY: "scroll",
										}}
									>
										{renderedRowsExamData}
									</div>
								)}
							</>
						) : (
							<>Loading</>
						)}
					</Typography>
				</AccordionDetails>
			</Accordion>
			<Accordion
				expanded={expanded === "panel3"}
				onChange={() => {
					if (expanded === "panel3") {
						setExpanded(false);
						return;
					}
					setExpanded("panel3");
					setType("hybrid");
				}}
			>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel3a-content"
					id="panel3a-header"
				>
					<Typography>Hybrid Results</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Typography>
						{!isLoading ? (
							<>
								{renderedRowsExamData && (
									<div
										style={{
											maxHeight: "40vh",
											minHeight: "40vh",
											height: "40vh",
											overflowY: "scroll",
										}}
									>
										{renderedRowsExamData}
									</div>
								)}
							</>
						) : (
							<>Loading</>
						)}
					</Typography>
				</AccordionDetails>
			</Accordion>
		</Container>
	);
};

export default SpecificUserData;
